import React, { Component } from "react"
import {
  Input,
  Button,
  Icon,
  Affix,
  Spin,
  Row,
  Select,
  Menu,
  DatePicker,
  Modal,
} from "antd"
import { observer, inject } from "mobx-react"
import { action } from "mobx"
import moment from "moment"
import DownloadLinkModal from "app/components/normal/DownloadLinkModal"

const RangePicker = DatePicker.RangePicker
const { Search } = Input
const Option = Select.Option

@inject("auth", "store") @observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.state = {
      dayKey: "-1",
      showDownloadLinkModal: false
    }
  }

  componentDidMount() {
    const { list: { getApps } } = this.props.store
    getApps('withAll')
  }

  // 搜索框更新
  @action
  changeSearch = (e) => {
    const keywords = e.target.value
    this.setState({
      inputSearch: keywords,
    })
  }

  searchData = () => {
    const {
      list: { filterData }
    } = this.props.store
    filterData({ keywords: this.state.inputSearch })
  }

  closeModal = (modal) => {
    this.setState({
      [modal]: false
    })
  }

  render() {
    return (
      <Affix
        className="affix-head"
        target={() => document.getElementsByClassName("salt-pagelayout")[0]} offsetTop={50}
      >
        <div className="affix-back">
          {this.renderSearchMenu()}
          {this.renderAppMenu()}
        </div>
      </Affix>
    )
  }

  onDataChange = (e, type) => {
    this.props.store.tableData = []

    switch (type) {
      case "belong": this.onBelongChange(e)
        break
      case "app": this.onAppChange(e)
        break
      case "day": this.onDayChange(e)
        break
      default: this.dateChangeOk()
    }
  }

  onAppChange = (e) => {
    const {
      list: { filterData, selectAllApp }
    } = this.props.store
    if (e.includes("all")) {
      filterData({ appIds: selectAllApp() })
    } else {
      filterData({ appIds: e })
    }
  }

  onDayChange = (e) => {
    let startDay = null
    const {
      list: { filterData }
    } = this.props.store

    this.setState({  //设置近几天同时重置日期选择
      dayKey: e.key,
      dateValue: null,
    })
    if (e.key !== "-1") {
      startDay = moment(moment() - e.key * 1000 * 3600 * 24).format("YYYY-MM-DD")
    }

    filterData({ start: startDay, end: null })
  }

  dateChange = (dateValue, dateString) => {
    const { list: { updateQueryMap } } = this.props.store
    updateQueryMap({ start: dateString[0], end: dateString[1] })
    this.setState({     //日期回显
      dateValue: dateValue
    })
  }

  dateChangeOk = () => {
    this.setState({  // 重置近几天的选项
      dayKey: "-1",
    })
    let {
      list: { filterData, queryMap }
    } = this.props.store

    filterData({ end: moment(queryMap.end, "YYYY-MM-DD").add(1, "days").format("YYYY-MM-DD") })
  }

  exportDataStep1 = () => {
    const { exportDataStep1 } = this.props.store
    this.props.store.exportModalShowed = true
    exportDataStep1()
  }

  showDownloadLinkModal = () => {
    this.setState({
      showDownloadLinkModal: true
    })
  }

  renderSearchMenu = () => {
    const { list: { totalCount }, exportModalShowed } = this.props.store

    return (
      <div className="statistics-search-bar">
        <Row type="flex" justify="space-between" align="middle" className="content">
          <Row type="flex" align="middle">
            <div className="search-input">
              <Search
                placeholder="输入文件名/样本名搜索"
                size="default"
                onChange={this.changeSearch}
                onSearch={this.searchData}
              />
            </div>
            <Menu className="menu-day" onClick={e => this.onDataChange(e, "day")}
              selectedKeys={[this.state.dayKey]}
              mode="horizontal"
              key="menu_date_0"
            >
              <Menu.Item key="-1">
                <Icon type="calendar" />全部
              </Menu.Item>
            </Menu>
            <RangePicker
              ranges={{
                "今天": [moment(), moment()],
                "本月": [moment().startOf("month"), moment()]
              }}
              showTime
              value={this.state.dateValue}
              onChange={this.dateChange}
              onOk={this.dateChangeOk}
              disabledDate={this.disabledDate}
            />
          </Row>
          <Row>
            <span>共 <span className="total-count">{totalCount}</span> 条数据</span>
            <Button
              type="primary"
              size="default"
              className="export-btn"
              onClick={this.exportDataStep1}
            >
              <Icon type="download" />导出
            </Button>
          </Row>
        </Row>
        <Modal
          className="statistics-export-modal"
          width={230}
          visible={exportModalShowed}
          footer={null}
        >
          <div className="export-loading"><Spin size="large" /></div>
          <div className="export-tips">正在导出中，请稍等。。。</div>
        </Modal>
      </div>
    )
  }

  renderAppMenu = () => {
    const { list: { apps, queryMap } } = this.props.store
    return (
      <Row type="flex" justify="space-between" align="middle" className="statistics-app-bar">
        <Row>
          应用筛选：
        <Select
            multiple
            style={{ minWidth: 300 }}
            placeholder="请选择应用进行筛选"
            value={queryMap.appIds.slice()}
            onChange={this.onAppChange}
            dropdownMatchSelectWidth={false}
          >
            {apps.slice().map(app => <Option key={app.id}>{app.name}</Option>)}
          </Select>
        </Row>
        <Row>
          <Button
            type="primary"
            size="default"
            className="export-btn"
            onClick={this.showDownloadLinkModal}
          >
            <Icon type="download" />数据下载
          </Button>
        </Row>
        {this.state.showDownloadLinkModal && (
          <DownloadLinkModal
            store={this.props.store}
            type="azf"
            onClose={() => this.closeModal('showDownloadLinkModal')}
          />
        )}
      </Row>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/research/azf/statistics/containers/DataHeader.js